// extracted by mini-css-extract-plugin
export default {"container":"PhiSwitch_container__gzkQu","label":"PhiSwitch_label__64ROS","note":"PhiSwitch_note__u4BXx"};